import React, { useRef, useState } from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { ASSET_URL } from '../../../../env/Configurations';
import { handleSlider } from '../../../../utils/UiBuilderUtils';
import './Carousel-Without-Background.scss';

const CarousalWithoutBackgroundPreview = (props) => {
  const { config } = props;
  const ref = useRef(null);
  const [additionalTransfrom, setAdditionalTransfrom] = useState(0);

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
  };

  const CustomSlider = ({ carouselState }) => {
    let value = 0;
    let carouselItemWidth = 0;
    if (ref?.current) {
      carouselItemWidth = ref?.current?.state?.itemWidth;
      const maxTranslateX = Math.round(
        carouselItemWidth * (ref?.current?.state?.totalItems - ref?.current?.state?.slidesToShow) +
          150,
      );
      value = maxTranslateX / 100;
      handleSlider(config, ref);
    }
    const { transform } = carouselState;
    return (
      <div className='custom-slider'>
        <input
          type='range'
          value={Math.round(Math.abs(transform) / value)}
          max={
            (carouselItemWidth * (carouselState.totalItems - carouselState.slidesToShow) +
              (additionalTransfrom === 150 ? 0 : 150)) /
            value
          }
          onChange={(e) => {
            if (ref?.current?.isAnimationAllowed) {
              ref.current.isAnimationAllowed = false;
            }
            const nextTransform = e.target.value * value;
            const nextSlide = Math.round(nextTransform / carouselItemWidth);
            if (e.target.value === 0 && additionalTransfrom === 150) {
              ref.current.isAnimationAllowed = true;
              setAdditionalTransfrom(0);
            }
            ref?.current?.setState({
              transform: -nextTransform,
              currentSlide: nextSlide,
            });
          }}
          className='custom-slider__input'
        />
      </div>
    );
  };

  return (
    <div className='potrait-carousal-no-background'>
      {config?.slides?.length && (
        <div>
          <div className='preview-title'>{config?.titleH2 ? config?.titleH2 : 'H2 Title'}</div>
          <div className='potrait-carousal-no-background-box'>
            <Carousel
              ref={ref}
              responsive={responsive}
              autoPlay={true}
              infinite={true}
              arrows={false}
              className='no_background'
              customButtonGroup={<CustomSlider />}
            >
              {config.slides.map((slide, key) => (
                <>
                  {!slide.isVideo && (
                    <div className='h-100' key={key}>
                      <div
                        className={`d-flex image-container-portrait justify-content-center align-items-center ${
                          slide?.shadowOverlay ? 'shadowed-img' : ''
                        }`}
                        key={key}
                        style={
                          slide.imgURL
                            ? {
                                backgroundImage: 'url(' + ASSET_URL + slide.imgURL + ')',
                                backgroundSize: 'cover',
                              }
                            : {}
                        }
                      >
                        <div className='slide-title'>{slide.imgURL ? '' : 'Image'}</div>
                      </div>
                      <div className='slide-title mt-1'>
                        {slide.titleH3 ? slide.titleH3 : 'H3 Title'}
                      </div>

                      {config?.isIconActive &&
                        slide?.icon?.iconList?.map(
                          (icon, key) =>
                            !icon.isHide && (
                              <div className='row d-flex'>
                                <div className='col-2'>
                                  <div
                                    className='d-flex icon-container justify-content-center align-items-center mb-2'
                                    key={key}
                                    style={
                                      icon.imgURL !== ''
                                        ? {
                                            backgroundImage: 'url(' + ASSET_URL + icon.imgURL + ')',
                                            backgroundSize: 'cover',
                                          }
                                        : {}
                                    }
                                  />
                                </div>
                                <div className='col-8 titleH4'>{icon?.titleH4}</div>
                              </div>
                            ),
                        )}
                    </div>
                  )}
                  {slide?.isVideo && (
                    <div className={`${slide?.shadowOverlay ? 'shadowed-img' : ''}`} key={key}>
                      <div className='image-container-portrait video-container-2c'>
                        <video
                          style={{
                            width: '89px',
                            height: '59px',
                            objectFit: 'fill',
                            position: 'relative',
                            top: 0,
                          }}
                          autoPlay
                          loop={slide?.loopPlayBack}
                          preload='auto'
                          src={slide?.videoURL}
                          muted
                        />
                        <div className='slide-title-2c'>{slide.videoURL ? '' : 'Video'}</div>
                        <div className='slide-title'>
                          {slide.titleH3 ? slide.titleH3 : 'H3 Title'}
                        </div>
                        {config?.isIconActive &&
                          slide?.icon?.iconList?.map(
                            (icon, key) =>
                              !icon.isHide && (
                                <div className='row d-flex'>
                                  <div className='col-2'>
                                    <div
                                      className='d-flex icon-container justify-content-center align-items-center mb-2'
                                      key={key}
                                      style={
                                        icon.imgURL !== ''
                                          ? {
                                              backgroundImage:
                                                'url(' + ASSET_URL + icon.imgURL + ')',
                                              backgroundSize: 'cover',
                                            }
                                          : {}
                                      }
                                    />
                                  </div>
                                  <div className='col-8 titleH4'>{icon?.titleH4}</div>
                                </div>
                              ),
                          )}
                      </div>
                    </div>
                  )}
                </>
              ))}
              {config?.viewAll?.isActive && (
                <div className='h-100'>
                  <div className='d-flex justify-content-center align-items-center view-all-portrait'>
                    <div className='slide-title'>View All</div>
                  </div>
                </div>
              )}
            </Carousel>
          </div>
        </div>
      )}
    </div>
  );
};

export default CarousalWithoutBackgroundPreview;
